import { useState, useEffect } from 'react'

export const useTaxonomies = (url, types = []) => {
    const [taxonomies, setTaxonomies] = useState({})
    const [error, setError] = useState(null)
    const [isLoading, setIsLoading] = useState(false)

    const fetchTaxonomies = async (url, types) => {
        setIsLoading(true)
        try {
            const typesQuery = types && Array.isArray(types)
                ? `&type=${types.join(',')}`
                : ''
            const newTaxonomies = await fetch(`${url}/taxonomies?per_page=100${typesQuery}`)
                .then(r => r.ok ? r.json() : {})

            for (const slug in newTaxonomies) {
                const terms = await fetch(`${newTaxonomies[slug].rest_base}`)
                    .then(r => r.ok ? r.json() : [])
                newTaxonomies[slug].terms = terms
            }
            setTaxonomies(newTaxonomies)

            setTaxonomies(newTaxonomies)
            setIsLoading(false)
        } catch (error) {
            setError(error)
        }
    }

    useEffect(() => {
        fetchTaxonomies(url, types)
    }, [])
    return [taxonomies, fetchTaxonomies, error, isLoading]
}

export default useTaxonomies